import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';

const Wrapper = styled.div`
  min-height: 100vh;
  background: #fafafa;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
`;

const Box = styled.div`
  width: 100%;
  max-width: 400px;
  background: #fff;
  border-radius: 16px;
  padding: 40px 20px 32px 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

const Title = styled.h1`
  font-size: 1.6rem;
  font-weight: 700;
  text-align: center;
  margin-bottom: 32px;
  line-height: 1.4;
`;

const TermsContent = styled.div`
  height: 300px;
  overflow-y: auto;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
  background: #fafafa;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
`;

const Button = styled.button`
  flex: 1;
  padding: 14px 0;
  border: none;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;

  &.agree {
    background: #000;
    color: #fff;
    &:disabled {
      background: #bdbdbd;
      cursor: not-allowed;
    }
  }

  &.cancel {
    background: #eee;
    color: #666;
  }
`;

const TermsPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isScrolledToBottom, setIsScrolledToBottom] = useState(false);
  const termsRef = useRef<HTMLDivElement>(null);

  const handleScroll = () => {
    if (termsRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = termsRef.current;
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        setIsScrolledToBottom(true);
      }
    }
  };

  useEffect(() => {
    const termsElement = termsRef.current;
    if (termsElement) {
      termsElement.addEventListener('scroll', handleScroll);
      return () => termsElement.removeEventListener('scroll', handleScroll);
    }
  }, []);

  const handleAgree = () => {
    navigate('/signup/privacy', { state: location.state });
  };

  const handleCancel = () => {
    navigate('/login');
  };

  return (
    <Wrapper>
      <Box>
        <Title>이용약관</Title>
        <TermsContent ref={termsRef}>
          <h3>제1조 (목적)</h3>
          <p>이 약관은 누북(이하 "회사")이 제공하는 서비스의 이용과 관련하여 회사와 회원 간의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.</p>
          
          <h3>제2조 (정의)</h3>
          <p>이 약관에서 사용하는 용어의 정의는 다음과 같습니다.</p>
          <p>1. "서비스"란 회사가 제공하는 모든 서비스를 의미합니다.</p>
          <p>2. "회원"이란 회사와 서비스 이용계약을 체결한 자를 말합니다.</p>
          
          <h3>제3조 (약관의 효력 및 변경)</h3>
          <p>1. 이 약관은 서비스를 이용하고자 하는 모든 회원에게 적용됩니다.</p>
          <p>2. 회사는 필요한 경우 약관을 변경할 수 있으며, 변경된 약관은 서비스 내 공지사항에 게시하거나 기타 방법으로 회원에게 공지함으로써 효력이 발생합니다.</p>
          
          <h3>제4조 (이용계약의 체결)</h3>
          <p>1. 이용계약은 회원이 되고자 하는 자가 약관의 내용에 대하여 동의를 한 다음 회원가입신청을 하고 회사가 이러한 신청에 대하여 승낙함으로써 체결됩니다.</p>
          <p>2. 회사는 다음 각 호에 해당하는 신청에 대하여는 승낙을 하지 않을 수 있습니다.</p>
          <p>- 기술상 서비스 제공이 불가능한 경우</p>
          <p>- 실명이 아니거나 타인의 명의를 이용한 경우</p>
          <p>- 허위의 정보를 기재하거나 회사가 요구하는 내용을 기재하지 않은 경우</p>
        </TermsContent>
        <ButtonGroup>
          <Button className="agree" onClick={handleAgree} disabled={!isScrolledToBottom}>
            동의
          </Button>
          <Button className="cancel" onClick={handleCancel}>
            취소
          </Button>
        </ButtonGroup>
      </Box>
    </Wrapper>
  );
};

export default TermsPage; 